module.exports = __webpack_public_path__ + "static/media/showcase_service@3x.2f9cb56b.png";